<template>
  <pt-link-form class="pt-link-form__page"></pt-link-form>
</template>

<script>
import PtLinkForm from 'cps/pt-link-manage/pt-link-form'
export default {
  name: 'pt-link-form__view',
  components: {
    'pt-link-form': PtLinkForm
  }
}
</script>
